import { render } from "./Sus.vue?vue&type=template&id=65db789d"
import script from "./Sus.vue?vue&type=script&lang=js"
export * from "./Sus.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__